import { SidebarComponent } from './../../sidebar/sidebar.component';
import { AfterViewInit, Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as feather from "feather-icons";
import { LayoutService } from "../../../services/layout.service";
import { NavService } from "../../../services/nav.service";
import { fadeInAnimation } from "../../../data/router-animation/router-animation";

@Component({
  selector: "app-content",
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
  animations: [fadeInAnimation],
})
export class ContentComponent implements OnInit, AfterViewInit {
  mainStyles: any = {};
  sidebarWidth: any;
  constructor(private route: ActivatedRoute, public navServices: NavService, public layout: LayoutService) {
    this.route.queryParams.subscribe((params) => {
      this.layout.config.settings.layout = params.layout ? params.layout : this.layout.config.settings.layout;
    });
  }

  ngOnInit() {
    this.updateMainStyles(window.innerWidth);
    this.sidebarWidth = this.navServices.getSidebarWidth();
    this.navServices.sidebarWidth.subscribe(width => {
      this.sidebarWidth = width;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateMainStyles(event.target.innerWidth);
  }

  updateMainStyles(width: number) {
    this.mainStyles = { width: `calc(100vw - ${this.sidebarWidth})` };
  }
  

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : "";
  }

  get layoutClass() {
    return "compact-wrapper";
  }

}
